import { Camera, MonitorUp, AlertTriangle, ClipboardPaste, ShieldCheck } from "lucide-react";

function Row({ icon: Icon, label, value, warn, testid }) {
  return (
    <div className="flex items-center justify-between gap-2 py-1.5 text-xs" data-testid={testid}>
      <span className="inline-flex items-center gap-2 text-slate-400"><Icon className="w-3.5 h-3.5" />{label}</span>
      <span className={`font-mono ${warn ? "text-amber-300" : "text-slate-200"}`}>{value}</span>
    </div>
  );
}

// Always-visible proctoring panel: right rail on desktop, small floating preview on smaller screens.
export function ProctorRail({ videoRef, proctor }) {
  return (
    <aside data-testid="proctor-rail"
      className="fixed bottom-4 right-3 z-30 w-28 sm:w-36 lg:static lg:w-auto lg:z-auto lg:border-l lg:border-[color:var(--bd-sub)] lg:p-4 lg:overflow-y-auto"
      style={{ background: "transparent" }}>
      <div className="hidden lg:flex items-center gap-2 mb-3 text-[11px] uppercase tracking-wider text-rose-300 font-semibold">
        <span className="tp-rec-pulse" /> Proctored session
      </div>
      <div className="relative">
        <video ref={videoRef} autoPlay playsInline muted data-testid="proctor-video"
          className="w-full aspect-video rounded-lg bg-black object-cover border border-rose-500/60 shadow-lg shadow-black/40" />
        <span className="absolute top-1.5 left-1.5 inline-flex items-center gap-1 text-[9px] font-semibold tracking-wider px-1.5 py-0.5 rounded bg-black/60 text-rose-300">
          <span className="w-1.5 h-1.5 rounded-full bg-rose-500 animate-pulse" /> REC
        </span>
      </div>
      <div className="hidden lg:block mt-4 divide-y divide-white/5">
        <Row icon={Camera} label="Camera" value={proctor.cam_live ? "On" : "Off"} warn={!proctor.cam_live} testid="proctor-cam" />
        <Row icon={MonitorUp} label="Screen" value={proctor.screen_live ? "Shared" : "Not shared"} warn={!proctor.screen_live} testid="proctor-screen" />
        <Row icon={AlertTriangle} label="Tab switches" value={proctor.tab_switches || 0} warn={proctor.tab_switches > 0} testid="proctor-tabs" />
        <Row icon={ClipboardPaste} label="Pastes" value={proctor.paste_events || 0} warn={proctor.paste_events > 0} testid="proctor-pastes" />
      </div>
      <p className="hidden lg:flex gap-2 mt-4 text-[11px] leading-relaxed text-slate-500">
        <ShieldCheck className="w-4 h-4 shrink-0 text-emerald-400" />
        Your camera, screen and activity are recorded for the hiring team. Stay on this tab until you submit.
      </p>
    </aside>
  );
}
